/** Catalogo template Pubblicità. access: 'basic' | 'premium' */

export const CATEGORIES = [
  { id: 'all', labelKey: 'advertising.categories.all' },
  { id: 'custom', labelKey: 'advertising.categories.custom' },
  { id: 'brand', labelKey: 'advertising.categories.brand' },
  { id: 'oggi', labelKey: 'advertising.categories.oggi' },
  { id: 'funny', labelKey: 'advertising.categories.funny' },
  { id: 'team', labelKey: 'advertising.categories.team' },
  { id: 'reviews', labelKey: 'advertising.categories.reviews' },
  { id: 'promo', labelKey: 'advertising.categories.promo' },
  { id: 'seasonal', labelKey: 'advertising.categories.seasonal' },
];

/** Frasi divertenti: prime 4 = Basic, resto = Premium */
export const FUNNY_PHRASE_IDS = [
  'divano',
  'ferie',
  'scusa',
  'taglio',
  'specchio',
  'barba',
  'weekend',
  'selfie',
  'poltrona',
  'app',
  'lunedi',
  'ritardo',
];

export const BASIC_FUNNY_COUNT = 4;

/** Una sola grafica stagionale alla volta, in base al periodo. */
export const getActiveSeasonalId = (date = new Date()) => {
  const month = date.getMonth();
  if (month >= 9) return 'xmas'; // ott–dic
  if (month === 8) return 'backToSchool'; // set
  return 'summer'; // gen–ago (estate come prossima/attuale)
};

/**
 * Generatori personalizzabili: vivono SOLO nella sezione "Su misura",
 * le altre sezioni contengono template pronti da condividere subito.
 */
export const CUSTOM_TEMPLATES = [
  { id: 'custom-slots', category: 'custom', kind: 'generateSlots', access: 'premium' },
  {
    id: 'custom-soldout',
    category: 'custom',
    kind: 'generateChair',
    access: 'premium',
    proposalType: 'soldout',
  },
  {
    id: 'custom-team',
    category: 'custom',
    kind: 'generateChair',
    access: 'premium',
    proposalType: 'spotlight',
  },
  { id: 'custom-review', category: 'custom', kind: 'generateReview', access: 'premium' },
  { id: 'custom-promo', category: 'custom', kind: 'generatePromo', access: 'premium' },
];

export const STATIC_TEMPLATES = [
  // Brand
  {
    id: 'brand-app',
    category: 'brand',
    kind: 'headline',
    access: 'basic',
    proposalType: 'appOnly',
  },
  {
    id: 'brand-book',
    category: 'brand',
    kind: 'headline',
    access: 'basic',
    proposalType: 'bookFast',
  },
  {
    id: 'brand-salon',
    category: 'brand',
    kind: 'headline',
    access: 'basic',
    proposalType: 'salon',
  },
  { id: 'brand-qr', category: 'brand', kind: 'qr', access: 'basic' },
  {
    id: 'brand-quality',
    category: 'brand',
    kind: 'headline',
    access: 'premium',
    proposalType: 'quality',
  },
  {
    id: 'brand-online',
    category: 'brand',
    kind: 'headline',
    access: 'premium',
    proposalType: 'online',
  },
  {
    id: 'brand-tap',
    category: 'brand',
    kind: 'headline',
    access: 'premium',
    proposalType: 'tapBook',
  },
  // Oggi
  {
    id: 'oggi-soldout',
    category: 'oggi',
    kind: 'headline',
    access: 'basic',
    proposalType: 'soldout',
  },
  {
    id: 'oggi-available',
    category: 'oggi',
    kind: 'headline',
    access: 'basic',
    proposalType: 'available',
  },
  {
    id: 'oggi-walkin',
    category: 'oggi',
    kind: 'headline',
    access: 'premium',
    proposalType: 'walkIn',
  },
  {
    id: 'oggi-nocalls',
    category: 'oggi',
    kind: 'headline',
    access: 'premium',
    proposalType: 'noCalls',
  },
  {
    id: 'oggi-lastspots',
    category: 'oggi',
    kind: 'headline',
    access: 'premium',
    proposalType: 'lastSpots',
  },
  {
    id: 'oggi-morning',
    category: 'oggi',
    kind: 'headline',
    access: 'premium',
    proposalType: 'morning',
  },
  {
    id: 'oggi-evening',
    category: 'oggi',
    kind: 'headline',
    access: 'premium',
    proposalType: 'evening',
  },
  {
    id: 'oggi-opennow',
    category: 'oggi',
    kind: 'headline',
    access: 'premium',
    proposalType: 'openNow',
  },
  // Team (statici; il generatore da poltrona è in "Su misura")
  {
    id: 'team-choose',
    category: 'team',
    kind: 'headline',
    access: 'premium',
    proposalType: 'chooseChair',
  },
  {
    id: 'team-vip',
    category: 'team',
    kind: 'headline',
    access: 'premium',
    proposalType: 'vip',
  },
  {
    id: 'team-spotlight',
    category: 'team',
    kind: 'headline',
    access: 'premium',
    proposalType: 'spotlight',
  },
  {
    id: 'team-style',
    category: 'team',
    kind: 'headline',
    access: 'premium',
    proposalType: 'style',
  },
  // Recensioni: teaser per i Basic (i Premium generano da "Su misura" o dalla pagina Recensioni)
  {
    id: 'reviews-teaser-1',
    category: 'reviews',
    kind: 'reviewTeaser',
    access: 'premium',
    teaserOnly: true,
  },
  {
    id: 'reviews-teaser-2',
    category: 'reviews',
    kind: 'reviewTeaser',
    access: 'premium',
    teaserOnly: true,
  },
  // Promo: teaser per i Basic (l'editor è in "Su misura")
  {
    id: 'promo-teaser',
    category: 'promo',
    kind: 'promoTeaser',
    access: 'premium',
    teaserOnly: true,
  },
];

/** Sezioni con tasto "Genera nuove" (mostra un sottoinsieme shuffled). */
export const REGENERATE_SECTION_IDS = new Set(['brand', 'oggi', 'funny', 'team']);
export const SECTION_VISIBLE_LIMIT = 4;

const mulberry32 = (seed) => {
  let t = seed >>> 0;
  return () => {
    t += 0x6d2b79f5;
    let r = Math.imul(t ^ (t >>> 15), 1 | t);
    r ^= r + Math.imul(r ^ (r >>> 7), 61 | r);
    return ((r ^ (r >>> 14)) >>> 0) / 4294967296;
  };
};

export const shuffleTemplates = (templates, seed) => {
  const a = [...templates];
  const rand = mulberry32(seed || 1);
  for (let i = a.length - 1; i > 0; i -= 1) {
    const j = Math.floor(rand() * (i + 1));
    const tmp = a[i];
    a[i] = a[j];
    a[j] = tmp;
  }
  return a;
};

/** QR resta fissato; le altre card ruotano. */
export const pickVisibleTemplates = (
  templates,
  seed,
  limit = SECTION_VISIBLE_LIMIT,
) => {
  if (!templates.length) return [];
  if (templates.length <= limit) return shuffleTemplates(templates, seed);

  const pinned = templates.filter((tpl) => tpl.kind === 'qr');
  const rest = templates.filter((tpl) => tpl.kind !== 'qr');
  const shuffled = shuffleTemplates(rest, seed);
  const slots = Math.max(0, limit - pinned.length);
  return [...pinned, ...shuffled.slice(0, slots)];
};

export const buildFunnyTemplates = () =>
  FUNNY_PHRASE_IDS.map((phraseId, index) => ({
    id: `funny-${phraseId}`,
    category: 'funny',
    kind: 'funny',
    phraseId,
    access: index < BASIC_FUNNY_COUNT ? 'basic' : 'premium',
  }));

export const buildSeasonalTemplates = (date = new Date()) => {
  const seasonalId = getActiveSeasonalId(date);
  return [
    {
      id: `seasonal-${seasonalId}`,
      category: 'seasonal',
      kind: 'seasonal',
      access: 'premium',
      seasonalId,
    },
  ];
};

export const getAllTemplates = (date = new Date()) => [
  ...CUSTOM_TEMPLATES,
  ...STATIC_TEMPLATES,
  ...buildFunnyTemplates(),
  ...buildSeasonalTemplates(date),
];

export const resolveTemplateAccess = (template, isPremium) => {
  if (template.teaserOnly) {
    return isPremium ? 'hidden' : 'teaser';
  }
  if (template.access === 'basic') return 'free';
  if (isPremium) return 'premium';
  return 'teaser';
};
